import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/syep14.png";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Ambassadors2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#ambassador-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            OUR <span className="purple"> AMBASSADORS </span> 
            </h1>
            <p className="home-about-body">
                        At Choicest Fruit<span className="small-r-symbol">®</span>, our Ambassadors are more than volunteers, they are <span className="purple"> youth leaders</span>, 
                        <span className="purple"> tech innovators</span>, and  <span className="purple">community changemakers</span>. They help us spread awareness, inspire 
                        participation, and bring technology education & training to life for children, youth and seniors 
                        in communities.
                        <br/>
                        The Ambassador Program is a systematic, localized effort to foster community life and 
                        advance social well-being through tech development, training, and service-oriented activities.
                        It empowers local communities, particularly in underserved areas, by building capacity, fostering 
                        mutual support, and cultivating positive qualities through a structured process of technology 
                        and service.
                        <br />
                        <br />
                        <h2>Who Can Be an Ambassador?</h2>
                         We welcome passionate youth ages 14–24 who:
                        <li>Are curious about technology development, STEM, and ethical innovation</li>
                        <li>Enjoy collaborating and leading projects</li>
                        <li>Want to make a real impact in your community </li>        
                        <br />
                        <h2>What Ambassadors Do</h2>
                         Ambassadors take part in initiatives designed to strengthen both tech skills and community life:
                        <li><span className="purple">Tech Skill-Building Sessions – </span> Training in coding, electronics, robotics, and digital tools to strengthen leadership and technical expertise.</li>
                        <li><span className="purple">STEM Workshop Series – </span>Designing and running monthly workshops for kids and teens.</li>
                        <li><span className="purple">Community Tech Help Days – </span> Assisting community members and local groups with technology challenges. </li>
                        <li><span className="purple">Tech Awareness Campaigns – </span> Spreading knowledge about digital literacy, responsible tech use, and ethical innovation. </li>  
                        <li><span className="purple">Mini STEM Project Showcases – </span> Presenting and mentoring youth-led projects. </li> 
                        <li><span className="purple">Community Engagement – </span> Recruiting participants, promoting STEM opportunities, and sharing Choicest Fruit programs with community members. </li>
                        <br />
                         These initiatives are carried out within neighborhoods, manageable geographic areas such as towns or parts of cities, ensuring efforts are sustained, coordinated, and inclusive.      
                        <br/>
                        <br />
                        <h2>Why Become an Ambassador?</h2>
                        Being a Choicest Fruit Ambassador offers youth:

                         <li><span className="purple">Hands-on experience</span> in responsible technology development and project leadership</li>
                         <li><span className="purple">Opportunities to teach and mentor</span> younger students and seniors</li>
                         <li><span className="purple">Recognition for community service hours</span> and potential stipends</li>
                         <li><span className="purple">The chance to make a tangible difference</span> while shaping the future of ethical technology</li>
                          <br />
                          Beyond immediate projects, Ambassadors help build new models of community life grounded in ethical principles, such as the
                           elimination of poverty, universal tech education, and the promotion of justice in technology development.
                          <br />
                          At the heart of it all is service. For Choicest Fruit, service means responding to the needs of others, uplifting neighborhoods & communities, 
                          and contributing to the betterment of humanity.
                          <br />                          
                        
          </p>
          <Button onClick={handleClick}>Apply Here</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
        {/* Responsive Video */}
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Ambassadors2;
